import React from 'react';
import { abbreviateAllVariants } from 'modules/abbreviate-all-variants';
import { SECTION_PRODUCT_INTRO } from 'constants/section-name';
import { SIZE_BIG } from 'constants/sizes';
import PropTypes from 'prop-types';
import { FloatingLogo } from 'components/floating-logo';
import { Title } from 'components/product-title';
import styles from './style.module.scss';
import { Link } from 'react-router-dom';
import { Button } from 'components/buttons';
import { useSelector } from 'react-redux';

export const ProductIntro = ({
  title,
  allVariants,
  introduction,
  smallScreen,
}) => {
  const varOptions = abbreviateAllVariants(allVariants);
  const variants = varOptions ? varOptions.join(' / ') : null;
  const productPageV2 = useSelector(
    (state) => state.product.data.productPageV2
  );

  const advert = useSelector((state) => state.product.data?.introAdvert);

  console.log('ad', advert);

  return (
    <section className={`${styles.intro} section container`}>
      <FloatingLogo section={SECTION_PRODUCT_INTRO} size={SIZE_BIG} />

      {productPageV2 && (
        <div className={`${styles['advert-container']} container`}>
          {smallScreen && (
            <>
              <Title title={title} />
              <h3>{variants}</h3>
            </>
          )}
          <p>{introduction}</p>
          {advert && (
            <div className={styles['advert-box']}>
              <div className={styles['advert-text']}>
                <h3>{advert[0].advert_heading}</h3>
                <Link to={advert[0].advert_link}>
                  <Button
                    size="small"
                    theme="dark"
                    label={advert[0].advert_cta_msg}
                  />
                </Link>
              </div>
              <div className={styles['overlay']}></div>
              {advert[0].advert_background.type === 'video' && (
                <video
                  autoPlay
                  muted
                  playsInline
                  loop
                  poster={advert[0].advert_background_image}
                >
                  <source
                    src={advert[0].advert_background.url}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              )}
              {advert[0].advert_background.type !== 'video' && (
                <video
                  autoPlay
                  muted
                  playsInline
                  loop
                  poster={advert[0].advert_background_image}
                >
                  <source type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          )}
        </div>
      )}
      {!productPageV2 && (
        <div className={`${styles['advert-container']} container`}>
          {smallScreen && (
            <>
              <Title title={title} />
              <h3>{variants}</h3>
            </>
          )}
          <p>{introduction}</p>
        </div>
      )}
    </section>
  );
};

ProductIntro.propTypes = {
  title: PropTypes.string.isRequired,
  allVariants: PropTypes.array,
  introduction: PropTypes.string.isRequired,
  smallScreen: PropTypes.bool,
};
